import { defineMessages } from 'react-intl-next';

export const messages: {
	remixToolbarTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	remixToolbarLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	remixBlockTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	remixBlockLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	remixToolbarTooltip: {
		id: 'highlight-actions.remix.inline-toolbar-tooltip',
		defaultMessage: 'Remix',
		description:
			'Tooltip for the Remix button in the editor inline toolbar that opens a modal to remix or regenerate the block content',
	},
	remixToolbarLabel: {
		id: 'highlight-actions.remix.inline-toolbar-label',
		defaultMessage: 'Remix',
		description:
			'Label for the Remix button in the editor inline toolbar that opens a modal to remix or regenerate the block content',
	},
	remixBlockTooltip: {
		id: 'block-hover.remix.remix-tooltip',
		defaultMessage: 'Remix',
		description:
			'Tooltip for the Remix button in the editor on block hover that opens a modal to remix or regenerate the block content',
	},
	remixBlockLabel: {
		id: 'block-hover.remix.remix-label',
		defaultMessage: 'Remix',
		description:
			'Label for the Remix button in the editor on block hover that opens a modal to remix or regenerate the block content',
	},
});
